import { Phone, Mail, MapPin } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Footer.css';
import logo from '../assets/logo/Remove_the_background_from_this_logo_image_make_i-1774710035371.png';

export default function Footer() {
  const navigate = useNavigate();
  const location = useLocation();

  const handleNav = (section) => {
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const el = document.getElementById(section);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
        else window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 100);
    } else {
      const el = document.getElementById(section);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
      else window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <footer className="footer">
      <div className="footer__top" />

      <div className="container footer__body">

        {/* Brand */}
        <div className="footer__brand">
          <img src={logo} alt="Rremi Rent a Car" className="footer__logo" />
          <p className="footer__tagline">
            Shërbim profesional i makinave<br />me qira në Kosovë.
          </p>
          <a href="tel:+38343888408" className="footer__brand-phone">
            <Phone size={14} />
            +383 43 888 408
          </a>
        </div>

        {/* Nav */}
        <div className="footer__col">
          <h4 className="footer__col-title">Navigimi</h4>
          <nav className="footer__nav">
            <button onClick={() => handleNav('hero')} className="footer__link">Kreu</button>
            <button onClick={() => handleNav('fleet')} className="footer__link">Flotë</button>
            <button onClick={() => handleNav('about')} className="footer__link">Rreth Nesh</button>
            <button onClick={() => handleNav('contact')} className="footer__link">Kontakti</button>
          </nav>
        </div>

        {/* Contact */}
        <div className="footer__col">
          <h4 className="footer__col-title">Kontakti</h4>
          <div className="footer__contact">
            <a href="tel:+38343888408" className="footer__contact-item">
              <Phone size={13} />
              +383 43 888 408
            </a>
            <a href="mailto:info@rremirentacar.com" className="footer__contact-item">
              <Mail size={13} />
              rentacarrremi@gmail.com
            </a>
            <div className="footer__contact-item">
              <MapPin size={13} />
              Prishtinë, Kosovë
            </div>
          </div>
        </div>

      </div>

      <div className="container footer__bottom">
        <p>© {new Date().getFullYear()} Rremi Rent a Car. Të gjitha të drejtat e rezervuara.</p>
        <p>Dizajnuar me ❤️ në Kosovë</p>
      </div>
    </footer>
  );
}